import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: auto;
  padding: 30px 0 60px;
  box-shadow: inset 2000px 0 0 0 rgba(246, 245, 246, 0.9);
  text-align: center;

  > div {
    padding: 0 60px;
    ${bp('sm')`
      padding: 0 30px;
    `}
  }

  h2 {
    ${props => props.theme.css.heading3};
    color: ${props => props.theme.palette.primary.alphaDark};
    margin-bottom: 40px;
  }

  p {
    font: ${font('default', 'normal', '18px/1.5')};
    color: ${props => props.theme.palette.primary.alphaDark};
  }
`
